(function () {
  if (window.__moussyCartUrgencyTimer) return;
  window.__moussyCartUrgencyTimer = true;

  var STORAGE_KEY = 'moussy:cartTimerStart';
  var DURATION_MS = 7 * 60 * 1000;
  var clearing = false;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getStart() {
    var raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? parseInt(raw, 10) : null;
  }

  function setStart(ts) {
    sessionStorage.setItem(STORAGE_KEY, String(ts));
  }

  function clearStart() {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  function emptyCartAndReload() {
    if (clearing) return;
    clearing = true;
    clearStart();
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .catch(function () {})
      .then(function () {
        window.location.reload();
      });
  }

  function tick() {
    var bar = document.querySelector('[data-cart-urgency-bar]');
    if (!bar) return;

    if (bar.dataset.cartHasItems === 'true' && !getStart()) {
      setStart(Date.now());
    }

    var start = getStart();
    if (!start) {
      bar.hidden = true;
      return;
    }

    var remaining = DURATION_MS - (Date.now() - start);
    if (remaining <= 0) {
      bar.hidden = true;
      emptyCartAndReload();
      return;
    }

    bar.hidden = false;
    var minutes = Math.floor(remaining / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    var m = bar.querySelector('[data-cart-urgency-minutes]');
    var s = bar.querySelector('[data-cart-urgency-seconds]');
    if (m) m.textContent = pad(minutes);
    if (s) s.textContent = pad(seconds);
  }

  // Detect a successful add-to-cart through the Cart AJAX API, regardless of
  // which component triggered it, by observing outgoing fetch calls. This
  // starts (or keeps) the 5-minute window the moment an item is actually
  // added — never on a plain page view.
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var promise = originalFetch.apply(this, arguments);
    if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      promise
        .then(function (response) {
          if (response && response.ok && !getStart()) {
            setStart(Date.now());
          }
        })
        .catch(function () {});
    }
    return promise;
  };

  setInterval(tick, 100);
  tick();
})();
